/*
 *  公共自定义指令
 */

// 权限指令 v-hasPermission:arg="id"
// 指令名称 hasPermission
// 类型 arg
// id 模块的权限码
import Vue from 'vue'
import { Message } from 'element-ui'
Vue.directive('hasPermission', {
  inserted: function (el, binding, vnode, oldVnode) {
    // 不传参数，不做处理
    if (!binding.value) return
    // 实时获取session权限
    const authList = sessionStorage.getItem('authList')
      ? JSON.parse(sessionStorage.getItem('authList')) : {}
    const menuList = authList.menu || []
    const id = binding.value
    const hasPermission = menuList.includes(id)
    if (!hasPermission) replaceSelf(el)
  }
})

/**
 * 元素禁用处理
 * @param {object} element dom元素
 */
function replaceSelf (element) {
  let span = element.cloneNode(true)
  span.href = 'javascript:void(0);' // 禁止a标签跳转
  const lang = localStorage.lang
  const message = lang === 'en'
    ? "Can't view this module, please ask for customer service for more authority"
    : '无此模块权限，如需查看请联系客户服务申请权限'
  span.onclick = () => {
    Message.error(message)
  }
  element.parentNode.replaceChild(span, element)
}



// WEBPACK FOOTER //
// ./src/directive/permission.js